import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ConfettiService, EventService, ScApiService } from '@sc-ui';
import { NotificationsService } from 'src/services/notifications.service';
import { NotificationsModalComponent } from '../notifications-modal/notifications-modal.component';
import { UserService } from 'src/services/user.service';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { texts } from './topbar.texts';

@Component({
  standalone: false,
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {

  texts = texts;

  @Input()
  language: 'de' | 'en' = 'de';

  @ViewChild(NgbDropdown)
  notificationsDropdown: NgbDropdown;

  @ViewChild(NotificationsModalComponent)
  notificationsModal: NotificationsModalComponent;

  constructor(
    public notifications: NotificationsService,
    public userService: UserService,
    private api: ScApiService,
    private events: EventService,    
    private confetti: ConfettiService,
    private router: Router
    ) { }

  ngOnInit() {

    this.notifications.load();

    this.events.channel('users/' + this.api.userId + '/ui').subscribe((e: any) => {
      console.log(e);
      if (e.Name == 'navigate') {
        var route = e.Payload.Route;
        this.router.navigateByUrl(route);
      }
      if (e.Name == 'confetti') {
        this.confetti.start(5);
      }
    });

  }

  showNotifications() {
    this.notifications.showModal();
  }

  logout() {
    this.api.logout().subscribe();
    this.events.unsubscribeAll();
    this.router.navigateByUrl('/login');
  }

  navigateItem(i)
  {
    if (i.Candidate)
    {
      this.router.navigateByUrl('/projects/' + i.Project.Id + '/candidates/' + i.Candidate.Id);
      return;
    }

    if (i.Project)
    {
      this.router.navigateByUrl('/projects/' + i.Project.Id);
    }
  }
}
